$(document).ready(function () {

  $('.list-menu--inline details').hover(
    function () {
      // ON HOVER → OPEN
      const $details = $(this);
      const $summary = $details.children('summary');

      $details.attr('open', true);              // open drawer
      $summary.attr('aria-expanded', 'true');   // accessible state
    },
    function () {
      // ON HOVER OUT → CLOSE
      const $details = $(this);
      const $summary = $details.children('summary');

      $details.removeAttr('open');              // close drawer
      $summary.attr('aria-expanded', 'false');  // reset state
    }
  );

});
